import { render, staticRenderFns } from "./costBasis.vue?vue&type=template&id=20ab4d4e&"
import script from "./costBasis.vue?vue&type=script&lang=ts&"
export * from "./costBasis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports